// extracted by mini-css-extract-plugin
export var addressFields = "_m1-0";
export var animationContainer = "_m1-1";
export var footer = "_m1-2";
export var lineItems = "_m1-3";
export var modalContent = "_m1-4";
export var orderName = "_m1-5";
export var strong = "_m1-6";
export var warning = "_m1-7";